export default "__VITE_PUBLIC_ASSET__412f7ae5__"